import { Mixpanel } from '../init';

export const expFiltersPageViewEvent = (query: any) => {
   Mixpanel.track('Exp Filters - Page View', {
      query: query,
   });
};

export const expFiltersSearchViewEvent = (query: any) => {
   Mixpanel.track('Exp Filters - Search View', {
      query: query,
   });
};

export const expFiltersDateSelectorEvent = (start_date: string, end_date: string) => {
   Mixpanel.track('Exp Filters - Date Selector', {
      start_date: start_date,
      end_date: end_date,
   });
};

export const expFiltersSearchBtnEvent = (query: any, start_date: any, end_date: any) => {
   Mixpanel.track('Exp Filters - Search Btn', {
      query: query,
      start_date: start_date,
      end_date: end_date,
   });
};

export const expFiltersSelectPriceRangeEvent = (low: number, high: number) => {
   Mixpanel.track('Exp Filters - Select Price Range', {
      low: low,
      high: high,
   });
};

export const expFiltersSelectLocationEvent = (location: string) => {
   Mixpanel.track('Exp Filters - Select Location', {
      location: location,
   });
};

export const expFiltersSelectExpCategoryEvent = (category: string) => {
   Mixpanel.track('Exp Filters - Select Exp Category', {
      category: category,
   });
};

export const expFiltersSelectGenderEvent = (gender: string) => {
   Mixpanel.track('Exp Filters - Select Gender', {
      gender: gender,
   });
};

export const expFiltersSelectSortByEvent = (sortBy: string | undefined) => {
   Mixpanel.track('Exp Filters - Select Sort By', {
      sortBy: sortBy,
   });
};
